<template>
	<van-nav-bar title="报名助手" @click-left="onClickLeft" />
	<van-form>
		<van-cell-group inset style="margin-top:5%">
			<van-field style="color:#1989fa" label="订单信息" class="icon icon-titles" disabled />

			<!-- 客户姓名 -->
			<!-- <van-field label="客户姓名">
				<template #input>
					<input v-model="user_name" class="pc-select" placeholder="请输入客户的姓名" />
				</template>
			</van-field> -->

			<!-- 业务类型 -->
			<van-field label="业务类型">
				<template #input>
					<select v-model="bussines1" class="pc-select no-arrow" @change="onBusinessChange">
						<option value="">请选择业务类型</option>
						<option v-for="item in columns_data1" :key="item.value" :value="item.text">{{ item.text }}
						</option>
					</select>
				</template>
			</van-field>

			<!-- 专业/工种 -->
			<van-field label="专业/工种">
				<template #input>
					<select v-model="bussines2" class="pc-select no-arrow" @change="onGongChange">
						<option value="">请选择专业/工种</option>
						<option v-for="item in columns_data8" :key="item.value" :value="item.text">{{ item.text }}
						</option>
					</select>
				</template>
			</van-field>

			<!-- 默认隐藏 -->
			<van-field class="lh-40" name="radio" v-show="show_it3">
				<template #input>
					<van-radio-group v-model="bussines3_id" direction="horizontal" @change="chossed_value">
						<van-radio v-for="option in radioOptions" :key="option.label"
							:name="option.id">{{option.label}}</van-radio>
					</van-radio-group>
				</template>
			</van-field>

			<van-field class="lh-40" name="price" label="订单金额" :error="!!errorMsg" :error-message="errorMsg">
				<template #input>
					<input v-model="price" placeholder="订单金额" class="price_input"
						:class="['custom-input', { 'custom-input-error': errorMsg }]" @input="validatePrice"
						@blur="validatePrice">
				</template>
			</van-field>

			<van-field class="lh-40" name="radio" label="收款单位">
				<template #input>
					<van-radio-group v-model="componey" direction="horizontal">
						<van-radio name="1">筑信学校</van-radio>
						<van-radio name="2" icon-size="18px">筑信企业</van-radio>
					</van-radio-group>
				</template>
			</van-field>

			<van-field class="lh-40" name="radio" label="告知书">
				<template #input>
					<van-radio-group v-model="is_sign" direction="horizontal">
						<van-radio name="1">要签订</van-radio>
						<van-radio name="0">不签订</van-radio>
					</van-radio-group>
				</template>
			</van-field>
		</van-cell-group>

		<div style="margin: 16px;">
			<van-button round block type="primary" @click="SentMessage()">
				提交
			</van-button>
		</div>

		<div v-if="!isLoggedIn" style="padding:0 16px; margin-top:20px;">
			<van-button round block type="default" @click="goWxLogin">
				点击企业微信授权登录
			</van-button>
		</div>
	</van-form>
</template>

<script>
	import '@vant/touch-emulator';
	import {
		Field,
		CellGroup,
		NavBar,
		showToast,
		showLoadingToast,
		closeToast,
		Cell,
		Switch,
		Picker
	} from 'vant';
	import axios from 'axios';
	import sha1 from 'js-sha1';
	import * as ww from '@wecom/jssdk';

	export default {
		data() {
			return {
				user_name: '',
				price: '',
				componey: '1',
				is_sign: '1',
				can_edit: true,
				subtract: 0,
				checked_value: [],
				columns_data1: [],
				columns_data8: [],
				errorMsg: '',
				bussines1: '',
				bussines2: '',
				bussines3_id: '',
				bussines_type: '无',
				radioOptions: [],
				pickerValue1: [],
				pickerValue2: [],
				show_it1: false,
				show_it2: false,
				show_it3: false, // 👈 默认不显示
				isLoggedIn: false,
				isLoading: false, // 👈 加这个
				pattern: /[\u4E00-\u9FA5]/,
				validator: (val) => /^\d+(\.\d{1,2})?$/.test(val),
			};
		},

		mounted() {
			this.checkLogin();
			this.getBussinesList();
			this.getCodeFromUrl();
			this.initWxConfig();
		},

		methods: {
			// 校验函数
			validatePrice() {
				const val = String(this.price ?? '').trim(); // 关键：转字符串
				if (val === '') {
					this.errorMsg = '请输入订单金额';
					return false;
				}
				const num = Number(val);
				if (isNaN(num) || num <= 0) {
					this.errorMsg = '请输入正确内容';
					return false;
				}
				this.errorMsg = '';
				return true;
			},

			onClickLeft() {
				history.back();
			},

			checkLogin() {
				const userId = localStorage.getItem('ww_user_id');
				this.isLoggedIn = !!userId;
			},

			goWxLogin() {
				const CORP_ID = 'wwc76de3cd7c5ce1be';
				const AGENT_ID = "1000113";
				const redirect_uri = encodeURIComponent('https://scrm.zhuxinedu.com/');
				const url =
					`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${CORP_ID}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&agentid=${AGENT_ID}&state=STATE#wechat_redirect`;
				window.location.href = url;
			},

			async getCodeFromUrl() {
				const urlParams = new URLSearchParams(window.location.search);
				const code = urlParams.get('code');
				if (!code) return;

				try {
					const res = await axios.post('https://ddz.zhuxinedu.com/api/index/ww_get_user_info', {
						code
					});
					localStorage.setItem('ww_user_id', res.data.ww_user_id);
					localStorage.setItem('ww_user_name', res.data.ww_user_name);
					localStorage.setItem('ww_department', res.data.ww_department);
					this.isLoggedIn = true;
					showToast('登录成功');
					window.history.replaceState({}, document.title, window.location.pathname);
				} catch (err) {
					showToast('登录失败');
				}
			},


			async initWxConfig() {
				try {
					// 注册企业微信 JSSDK
					ww.register({
						corpId: 'wwc76de3cd7c5ce1be',
						agentId: 1000113,
						jsApiList: ['sendChatMessage'],

						// ✅ 关键：每次需要签名时，都会重新获取 ticket + 重新生成签名（永不失效）
						async getAgentConfigSignature() {
							try {
								// 1. 每次都从服务端拿最新 ticket（核心修复）
								const res = await axios.get(
									'https://ddz.zhuxinedu.com/api/index/get_agent_signature');
								const agent_ticket = res.data;

								// 2. 每次都生成新的随机串 + 时间戳（绝对不能复用旧的）
								const noncestr = Math.random().toString(36).slice(2, 8);
								const timestamp = Math.floor(Date.now() / 1000);
								const this_url = window.location.href.split('#')[0];

								// 3. 重新签名
								const str =
									`jsapi_ticket=${agent_ticket}&noncestr=${noncestr}&timestamp=${timestamp}&url=${this_url}`;
								const signature = sha1(str);

								return {
									timestamp,
									nonceStr: noncestr,
									signature
								};
							} catch (err) {
								console.error('获取签名失败', err);
								throw err;
							}
						},

						onAgentConfigSuccess: () => {
							console.log('✅ 企业微信配置成功');
						},
						onAgentConfigFail: (err) => {
							console.error('❌ 配置失败', err);
						}
					});
				} catch (e) {
					console.error('初始化失败', e);
				}
			},
			async getBussinesList() {
				const res = await axios.post('https://ddz.zhuxinedu.com/api/index/get_bussines_choose_data', {
					field: "yewu"
				});
				this.columns_data1 = res.data.map(item => ({
					text: item,
					value: item
				}));
			},

			async onBusinessChange() {
				this.bussines2 = '';
				this.bussines3_id = '';
				this.price = '';
				this.bussines_type = '无';
				this.radioOptions = [];
				this.show_it3 = false;

				const selected = this.columns_data1.find(item => item.text === this.bussines1);
				if (!selected) return;

				this.pickerValue1 = [selected.value];

				const res = await axios.post('https://ddz.zhuxinedu.com/api/index/get_jdy_entry_list', {
					yewu: selected.value
				});

				const list = res.data.map(item => ({
					text: item.gong,
					value: item.gong
				}));
				this.columns_data8 = [...new Map(list.map(item => [item.value, item])).values()];
			},

			async onGongChange() {
				this.price = '';
				this.bussines3_id = '';
				this.bussines_type = '无';

				this.show_it3 = false; // 每次切换先隐藏
				this.isLoading = true; // 👈 开始加载

				const selected = this.columns_data8.find(item => item.text === this.bussines2);
				if (!selected) {
					this.isLoading = false;
					return;
				}

				this.pickerValue2 = [selected.value];

				try {
					const res = await axios.post('https://ddz.zhuxinedu.com/api/index/get_jdy_entry_list', {
						yewu: this.pickerValue1[0],
						gong: selected.value
					});

					const arr = res.data
						.map(item => ({
							id: item._id,
							label: item.type,
							value: item.price
						}))
						.filter(item => item.label !== "无");

					this.radioOptions = arr;
					this.show_it3 = arr.length > 0;
				} catch (err) {
					// 网络失败时，强制清空 + 禁止提交
					this.radioOptions = [];
					this.show_it3 = false;
					showToast('获取类型失败，请重新选择专业/工种');
				} finally {
					this.isLoading = false; // 👈 结束加载
				}
			},

			chossed_value() {
				const selected = this.radioOptions.find(item => item.id === this.bussines3_id);
				if (!selected) {
					this.price = '';
					this.bussines_type = '无';
					this.checked_value = {};
					return;
				}
				this.bussines_type = selected.label;
				this.price = selected.value;
				this.checked_value = selected;
				console.log(this.price, '价格')
				console.log(this.bussines_type, '22222')
				console.log(this.checked_value, '选择的值')
			},
			async SentMessage() {
				if (!this.isLoggedIn) {
					showToast('请先登录');
					return;
				}
				// 2. 正在加载中，禁止提交
				if (this.isLoading) {
					showToast('正在加载选项，请稍候...');
					return;
				}

				//!this.user_name ||
				if (!this.bussines1 || !this.bussines2 || !this.price) {
					showToast('请完整填写');
					return;
				}

				// 👇👇👇 核心：有选项必须选，不允许默认“无”提交 👇👇👇
				if (this.radioOptions.length > 0 && !this.bussines3_id) {
					showToast('请选择具体类型');
					return;
				}

				showLoadingToast({
					forbidClick: true
				});
				const order_id = new Date().toISOString().slice(0, 10) + Math.random().toString().slice(-5);

				try {
					const res = await axios.post('https://ddz.zhuxinedu.com/api/index/sent_reg_info', {
						// user_name: this.user_name,
						price: this.price,
						bussines_type: this.bussines1,
						subject: this.bussines2,
						type: this.checked_value?.label || '无',
						subtract: this.subtract,
						componey: this.componey,
						is_sign: this.is_sign,
						ww_user_id: localStorage.getItem('ww_user_id'),
						ww_user_name: localStorage.getItem('ww_user_name'),
						ww_department: localStorage.getItem('ww_department'),
						order_id
					});

					if (res.data === 'Failed') {
						throw new Error('接口校验失败，不允许生成');
					}

					const imgRes = await axios.post('https://ddz.zhuxinedu.com/api/index/get_img', {
						text: order_id + this.bussines1,
						amount: this.price
					});
					
					console.log(imgRes,'图片地址')
					const share_img = imgRes.data;

					ww.sendChatMessage({
						msgtype: 'miniprogram',
						miniprogram: {
							appid: "wx6c29fdf36fa14e23",
							title: order_id + this.bussines1 + this.bussines2 + (this.checked_value
								?.label || ''),
							imgUrl: share_img,
							page: "pages/index/index.html?order_id=" + order_id,
						},
						success: () => {
							closeToast();
							showToast('订单生成并分享成功！');
						},
						fail: (err) => {
							closeToast();
							showToast('小程序发送失败:' + JSON.stringify(err));
							// 打印真实错误原因（关键！）
							console.error('企业微信错误详情：', err);
						}
					});
				} catch (err) {
					closeToast();
					showToast('提交失败：' + (err.message || '类型不允许或参数错误'));
				}
			}
		}
	};
</script>

<style>
	.lh-40 {
		line-height: 40px !important;
	}

	.van-picker {
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.pc-select {
		width: 100%;
		padding: 8px 12px;
		border: 1px solid #eee;
		border-radius: 6px;
		font-size: 15px;
		outline: none;
		background: #fff;
	}

	.pc-select:focus {
		border-color: #1989fa;
	}

	.no-arrow {
		appearance: none;
		-webkit-appearance: none;
		background-image: none;
	}

	.price_input {
		width: 100%;
		border: solid 1px #eee;
		border-radius: 6px;
		padding: 0 10px;
	}

	.van-field {
		align-items: center !important;
		/* 垂直居中 */
	}

	.van-field__label {
		align-self: center !important;
	}

	.van-field__control {
		align-self: center !important;
	}
</style>